import kaplay from 'kaplay'
import * as Colyseus from "colyseus.js";
import type { MyRoomState } from "../Server/src/rooms/schema/MyRoomState"
import { createMenuScene, loadScreenAssets } from "./scenes/menu"
import { createHostWaitingScene } from "./scenes/host-waiting"
import { createControllerScene } from './scenes/controller';
import { createControllerGameOverScene } from './scenes/controller-game-over';
import { createGameplayScene } from './scenes/gameplay';
import { createScreenGameOverScene } from './scenes/screen-game-over';
import { start } from 'repl';

// Initialize Kaplay
const canvas = document.getElementById("gameContainer") as HTMLCanvasElement;
export const k = kaplay({
	background: "41D9FF",
	canvas: canvas
});


// Connect to server
export var client = new Colyseus.Client({ hostname: "server.airparty.app", secure: true }); // 

// Create scenes
loadScreenAssets();
createMenuScene();
createHostWaitingScene();
createControllerScene();
createControllerGameOverScene();
createGameplayScene();
createScreenGameOverScene();

// Only allow running on whitelisted domain
var whitelistedDomains = ["127.0.0.1:1234", "localhost:1234", "airparty.app", "itch.io", "fireredplays.itch.io", "html-classic.itch.zone"];
if (whitelistedDomains.includes(window.location.host)) {
	if (location.hash != "") {
		client.joinById<MyRoomState>(location.hash.substring(1)).then(room => {
			k.go("controller", room);
		}).catch(e => {
			location.hash = "";
			location.reload();
		});
	}
	else {
		k.go("menu");
	}
} else {
}

